import { atom } from "jotai";

export const stockListAtom = atom([]);
